import { createFeatureSelector, createSelector } from '@ngrx/store';
import { initSettings, WebshopSettingsState } from './WebshopSettingsReducer';

export const selectWebshopSettings = createFeatureSelector<WebshopSettingsState>('webshopSettings');

export const initWebshopSettings = createSelector(
  selectWebshopSettings,
  initSettings
);
